"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MobileHandlerV2 = void 0;
const mobileHandler_1 = require("../mobileHandler");
class MobileHandlerV2 extends mobileHandler_1.MobileHandler {
    constructor(deviceConnector) {
        super(deviceConnector);
        this._requests = {};
        this.getResponse = (type, data) => {
            if (!this._requests[data.id]) {
                throw new Error(`Request: ${data.id} does not exist on requests list`);
            }
            if (!data.ack) {
                throw new Error(`Request: ${data.id} of type ${type} does not allow`);
            }
            this._requests[data.id](data);
            this._requests[data.id] = null;
        };
        this.callWithTimeout = (type, timeout, payload) => __awaiter(this, void 0, void 0, function* () {
            const requestId = payload.id || type;
            this.checkDeviceConnectorAndRequestType(requestId);
            const waiter = this.createCallPromise(timeout, requestId);
            this.deviceConnector.call(type, payload);
            return waiter;
        });
        this.deviceConnector = deviceConnector;
    }
}
exports.MobileHandlerV2 = MobileHandlerV2;
//# sourceMappingURL=mobileHandler.js.map